// extracted by mini-css-extract-plugin
export default {"tabsWrapper":"ProjectReportsTabs_tabsWrapper__VpwRD"};